import { type ReactElement, useCallback } from 'react'
import { useSnapshot } from 'valtio'
import Link from 'next/link'
import { globalUserProxy } from '../../../proxies/globalUserProxy'
import { APP_SETTINGS_ACCOUNT_PATH } from '../../../../pages/app/settings/account'
import MegaphoneIcon from '../../ui/icons/MegaphoneIcon'
import XMarkIcon from '../../ui/icons/XMarkIcon'

interface BannerProps {
  shouldDisplay: boolean | undefined
}

export function ChangePasswordBanner ({ shouldDisplay }: BannerProps): ReactElement {
  const { isPasswordBannerDismissed } = useSnapshot(globalUserProxy)
  const toggleDismissed = useCallback(
    () => { globalUserProxy.isPasswordBannerDismissed = !globalUserProxy.isPasswordBannerDismissed },
    []
  )

  if (shouldDisplay && !isPasswordBannerDismissed) {
    return (
      <div className="bg-red-500">
        <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between">
            <div className="flex w-0 flex-1 items-center">
              <span className="flex rounded-lg bg-std-dark-cool-gray-500 p-2">
                <MegaphoneIcon />
              </span>
              <p className="mx-auto truncate font-medium text-white">
                <span>Your password is overdue for a change.  Please Update your password.</span>
              </p>
            </div>
            <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto rounded-md border border-transparent bg-std-dark-cool-gray-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-std-dark-cool-gray-100">
              <Link
                href={APP_SETTINGS_ACCOUNT_PATH}
                className="flex items-center justify-center rounded-md border border-transparent bg-std-dark-cool-gray-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-std-dark-cool-gray-100"
              >
                Update
              </Link>
            </div>
            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
              <button
                onClick={toggleDismissed}
                type="button"
                className="-mr-1 flex rounded-md p-2 hover:bg-std-dark-cool-gray-100 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (<></>)
}
